// This file was automatically generated from print.medsList.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.medsList');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medsList.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  if (opt_data.now) {
    el8.template.print.currentAsOf(opt_data, output);
  }
  output.append('<h1 class="documentTitle">Current Medications</h1>');
  el8.template.print.patientInfo(opt_data, output);
  output.append('<h4>Current Prescription Meds</h4>');
  if (opt_data.rxMedsSummary && opt_data.rxMedsSummary.length) {
    output.append('<ol class="numberedList">');
    var mList15607 = opt_data.rxMedsSummary;
    var mListLen15607 = mList15607.length;
    for (var mIndex15607 = 0; mIndex15607 < mListLen15607; mIndex15607++) {
      var mData15607 = mList15607[mIndex15607];
      el8.template.print.medsList._currentMedication(mData15607, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No prescription medications currently taken.</p>');
  }
  output.append('<h4>Current OTC Meds</h4>');
  if (opt_data.otcMedsSummary && opt_data.otcMedsSummary.length) {
    output.append('<ol class="numberedList">');
    var mList15617 = opt_data.otcMedsSummary;
    var mListLen15617 = mList15617.length;
    for (var mIndex15617 = 0; mIndex15617 < mListLen15617; mIndex15617++) {
      var mData15617 = mList15617[mIndex15617];
      el8.template.print.medsList._currentMedication(mData15617, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No OTC medications currently taken.</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medsList._currentMedication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item">', soy.$$escapeHtml(opt_data.medicationName), ' sig: ', (opt_data.prescription.directions) ? soy.$$escapeHtml(opt_data.prescription.directions) : '', (opt_data.prescription.indication) ? ', for ' + soy.$$escapeHtml(opt_data.prescription.indication) : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medsList.comprehensiveContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  if (opt_data.now) {
    el8.template.print.currentAsOf(opt_data, output);
  }
  output.append('<h1 class="documentTitle">Medications History</h1>');
  el8.template.print.patientInfo(opt_data, output);
  output.append('<h4>Current Prescription Meds</h4>');
  if (opt_data.permRx && opt_data.permRx.length) {
    output.append('<ol class="numberedList">');
    var mList15648 = opt_data.permRx;
    var mListLen15648 = mList15648.length;
    for (var mIndex15648 = 0; mIndex15648 < mListLen15648; mIndex15648++) {
      var mData15648 = mList15648[mIndex15648];
      el8.template.print.medsList._comprehensiveMedication(mData15648, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No prescription medications currently taken.</p>');
  }
  output.append('<h4>Current OTC Meds</h4>');
  if (opt_data.permOtc && opt_data.permOtc.length) {
    output.append('<ol class="numberedList">');
    var mList15658 = opt_data.permOtc;
    var mListLen15658 = mList15658.length;
    for (var mIndex15658 = 0; mIndex15658 < mListLen15658; mIndex15658++) {
      var mData15658 = mList15658[mIndex15658];
      el8.template.print.medsList._comprehensiveMedication(mData15658, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No OTC medications currently taken.</p>');
  }
  output.append('<h4>Temporary Meds</h4>');
  if (opt_data.temporary && opt_data.temporary.length) {
    output.append('<ol class="numberedList">');
    var mList15668 = opt_data.temporary;
    var mListLen15668 = mList15668.length;
    for (var mIndex15668 = 0; mIndex15668 < mListLen15668; mIndex15668++) {
      var mData15668 = mList15668[mIndex15668];
      el8.template.print.medsList._comprehensiveMedication(mData15668, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No temporary medications currently taken.</p>');
  }
  output.append('<h4>Discontinued Meds</h4>');
  if (opt_data.discontinued && opt_data.discontinued.length) {
    output.append('<ol class="numberedList">');
    var mList15678 = opt_data.discontinued;
    var mListLen15678 = mList15678.length;
    for (var mIndex15678 = 0; mIndex15678 < mListLen15678; mIndex15678++) {
      var mData15678 = mList15678[mIndex15678];
      el8.template.print.medsList._comprehensiveMedication(mData15678, output);
    }
    output.append('</ol>');
  } else {
    output.append('<p>No discontinued medications recorded.</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medsList._comprehensiveMedication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item"><div class="el8DateYrMM el8ItemWithCount">', soy.$$escapeHtml(opt_data.startDate), '</div><p class="el8ItemWithDate"><span>', soy.$$escapeHtml(opt_data.displayName), (opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '', '</span></p>');
  if (opt_data.medNames && opt_data.medNames.length) {
    output.append('<p class="el8ItemWithDate el8AppText">Also includes: ');
    var nameList15698 = opt_data.medNames;
    var nameListLen15698 = nameList15698.length;
    for (var nameIndex15698 = 0; nameIndex15698 < nameListLen15698; nameIndex15698++) {
      var nameData15698 = nameList15698[nameIndex15698];
      output.append(soy.$$escapeHtml(nameData15698), (! (nameIndex15698 == nameListLen15698 - 1)) ? ', ' : '');
    }
    output.append('</p>');
  }
  output.append('</li>');
  if (!opt_sb) return output.toString();
};
